import React, { ReactNode } from 'react';
import { LoginContextProvider } from '@ww/react-ui-components';

function StoresContext({ children }: { children: ReactNode }) {
  return <LoginContextProvider>{children}</LoginContextProvider>;
}

export default StoresContext;
